const generateLocalizationKey = ({ type, fieldID, instanceID }) => {
  return `${type}-${fieldID}-${instanceID}`
}
export default generateLocalizationKey
